import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePositionStateStore = defineStore('positionStateStore', () => {
  const positionState = ref({})

  function setPositionState(planYearId, key, value, subKey = null) {
    if (!(planYearId in positionState.value)) {
      positionState.value[planYearId] = {}
    }
    if (subKey) {
      if (!(key in positionState.value[planYearId])) {
        positionState.value[planYearId][key] = {}
      }
      positionState.value[planYearId][key][subKey] = value
      return
    }
    positionState.value[planYearId][key] = value
  }

  function getPositionState(planYearId, key, subKey = null) {
    if (planYearId in positionState.value) {
      if (subKey) {
        if (key in positionState.value[planYearId]) {
          return positionState.value[planYearId][key][subKey]
        }
        return null
      }
      return positionState.value[planYearId][key]
    }
    return null
  }

  return {
    positionState,
    setPositionState,
    getPositionState
  }
})
